import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Categories} from "../../models/categories";
import {MatMenuTrigger} from "@angular/material/menu";
import {Router} from "@angular/router";
import {RegistryService} from "../../services/registry.service";
import {MatSidenav} from "@angular/material/sidenav";
import {SideBarService} from "../site-layout/sidebar.service";


@Component({
    selector: 'app-menu-mega',
    templateUrl: './menu-mega.component.html',
    styleUrls: ['./menu-mega.component.css']
})
export class MenuMegaBSComponent implements OnInit, OnDestroy {
    cat: Categories[];
    fullCat: any[];
    subCat: any = [];
    children: any = [];
    childrenCat: any = [];
    // @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
    menuTree: any;


    @ViewChild('sidenav') sidenav: MatSidenav;
    isExpanded = true;
    showSubmenu: boolean = false;
    isShowing = false;
    showSubSubMenu: boolean = false;
    catloadedevent;

    constructor(private router: Router, public registry: RegistryService,   public sideBarService: SideBarService,) {
        this.router.routeReuseStrategy.shouldReuseRoute = () => {
            return false;
        };


        // registry.ConfigsLoadedEvent$.subscribe(result=>{
        //     this.
        // })
    }

    mouseenter() {
        if (!this.isExpanded) {
            this.isShowing = true;
        }
    }

    mouseleave() {
        if (!this.isExpanded) {
            this.isShowing = false;
        }
    }


    ngOnInit(): void {
        this.cat = [];
        this.fullCat = this.registry.getFullCat();
        this.catloadedevent = this.registry.CatsLoadedEvent$.subscribe(result => {
            // this.fullCat = result;
            this.fullCat = this.registry.getFullCat();
            this.menuTree = this.buildMenu(this.fullCat[1]);
            
        });

        if (this.fullCat != null) {

            this.menuTree = this.buildMenu(this.fullCat[1]);
        }

    }

    buildMenu(root) {

        let children = [];
        children = this.getCatChildren(root);
        let m1 = {id: root.id, name: root.name, children: children};
        return m1;
    }

    getCatChildren(cat) {

        let childrenCats = [];

        if(cat == null)
        {
            return [];
        }
        if (cat.children == "") {
            return [];
        }
        this.children = cat.children.split(',');

        this.children.forEach(e => {

            if (e == "815" || e == "814" || e == "813") {
                return;
            }

                let chilCat = this.fullCat.filter(v => v.id === Number(e));
                let children = this.getCatChildren(chilCat[0])
                let m1 = {id: chilCat[0].id, name: chilCat[0].name, children: children};
                //this.menuTree.push(m1);
                childrenCats.push(m1);
                this.getCatChildren(chilCat[0]);

            }
        );

        return childrenCats

    }

    // getSubCat(id) {
    //     this.childrenCat = [];
    //     this.subCat = this.cat.filter(v => v.id === id);
    //     this.children = this.subCat[0].children.split(',');
    //     this.children.forEach(e =>
    //         this.childrenCat = this.childrenCat.concat(this.fullCat.filter(v => v.id === Number(e)))
    //     );
    // }

    goToProductBrowserPage(id) {

        this.router.navigate(['/web/home/categories', id]);
    }

    goToCategoriesPage(id) {
        this.router.navigate(['/web/home/categories', id]);

    }

    ngOnDestroy(): void {


        if (this.catloadedevent != null) {
            this.catloadedevent.unsubscribe();
        }
    }

}
